import { Automation } from 'domain/entity/automation';
import getGenericUseCase from 'use-case/genericUseCase';

const getReadAutomationsUseCase = getGenericUseCase<Automation[], null>((client) => client(null));

export default getReadAutomationsUseCase;
